import api from '../../api/countries';

export default {
    state: {
        countries: null,
    },
    getters: {
        getCountries: (state) => state.countries,
    },
    mutations: {
        SET_COUNTRIES_DATA(state, payload) {

            var countries = [];
            for (var i in payload) {
                countries.push({code: i, text: payload[i]});
            }
            state.countries = countries;
        },
    },
    actions: {
        fetchCountries({
            commit
        }) {
            api.get().then(({
                data: {
                    data: {
                        countries
                    }
                },
                status
            }) => {
                if (status === 200) {
                    commit('SET_COUNTRIES_DATA', countries);
                }
            });
        }
    },
};